import { safeParse } from '@/utils/misc';
import { User } from '@/types/index';

const userKey = 'user';
const accessTokenKey = 'accessToken';
const refreshTokenKey = 'refreshToken';

const getLocalStorageJson = <T>(key: string) => {
  const data = localStorage.getItem(key);
  const stored = data ? safeParse<T>(data) : undefined;
  return stored || undefined;
};

const setLocalStorageJson = <T>(key: string, data: T) =>
  localStorage.setItem(key, JSON.stringify(data));

export const getUserFromStorage = () => getLocalStorageJson<User>(userKey);

export const unsetUserInStorage = () => localStorage.setItem(userKey, '');

export const setUserInStorage = (user: User) => setLocalStorageJson(userKey, user);

export const getAccessTokenFromStorage = () =>
  localStorage.getItem(accessTokenKey) as string | undefined;

export const setAccessTokenInStorage = (accessToken: string) => {
  localStorage.setItem(accessTokenKey, accessToken);
};

export const unsetAccessTokenInStorage = () => {
  localStorage.removeItem(accessTokenKey);
};

export const getRefreshTokenFromStorage = () =>
  localStorage.getItem(refreshTokenKey) as string | undefined;

export const setRefreshTokenInStorage = (refreshToken: string) => {
  localStorage.setItem(refreshTokenKey, refreshToken);
};

export const unsetRefreshTokenInStorage = () => {
  localStorage.removeItem(refreshTokenKey);
};
